import keyMirror from "@kopapro-redux/utils/key-mirror";

export default keyMirror({
  GET_DELIVERYMETHODS_REQUEST: null,
  RECEIVED_DELIVERYMETHODS: null,
});
